module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 2224
// module chunks = 1